import { createContext, useContext, useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import Tabs, { tabConfig } from './Tabs'
import { BasePathProvider, useSession } from 'components/Providers'
import { Box, Paper } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import LeaveRequestPage from './LeaveRequests'
import PunchRecords from './PunchRecords'
import PunchApprovals from './PunchApprovals'
import LeaveApprovals from './LeaveApprovals'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import Protected from 'components/Protected'
import NotFound from 'components/NotFound'
import { hasPermission } from 'store'
import { useSelector } from 'react-redux'

const basePath = '/leave-request'

const canAccessRequestAndPunch = () => hasPermission('leave.leave')
const canAccessRequestApprovals = () => hasPermission('leave.request')
const canAccessPunchApprovals = () => hasPermission('leave.punch')

const SelectedTeacherContext = createContext(null)

export function useSelectedTeacher() {
  return useContext(SelectedTeacherContext)
}

export default function LeaveRequest() {
  const { person, district } = useSession()
  const allStaff = useSelector(state => state.lookup.allStaff?.rows)

  const hasHR = hasPermission('hr.leave')
  const hasPunch = hasPermission('leave.punch')
  const mode = (!hasHR && !hasPunch) ? 'self'
    : (hasHR && !hasPunch) ? 'hr'
      : (!hasHR && hasPunch) ? 'admin'
        : district?.isServiceProvider ? 'hr'
          : 'admin'

  const [selectedTeacher, setSelectedTeacher] = useState(null)

  useEffect(() => {
    if (mode === 'self') {
      setSelectedTeacher({ personId: person.id, person })
    } else if (mode === 'admin') {
      setSelectedTeacher(allStaff?.find(s => s.personId === person.id) ?? null)
    }
  }, [allStaff, mode])

  return (
    <SelectedTeacherContext.Provider value={{ selectedTeacher, setSelectedTeacher, mode }}>
      <BasePathProvider value={`${basePath}/`}>
        <Box sx={{ mb: 2 }}>
          <PageHeader title={'Leave Request'} />
        </Box>
        <Paper sx={{ width: '100%', p: 2 }}>
          <Tabs />
          <Routes>
            <Route path="/">
              <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
              <Route path="request/*" element={<Protected allowed={canAccessRequestAndPunch}><LeaveRequestPage /></Protected>} />
              <Route path="leave-approvals/*" element={<Protected allowed={canAccessRequestApprovals}><LeaveApprovals /></Protected>} />
              <Route path="punch-records/*" element={<Protected allowed={canAccessRequestAndPunch}><PunchRecords /></Protected>} />
              <Route path="punch-approvals/*" element={<Protected allowed={canAccessPunchApprovals}><PunchApprovals /></Protected>} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Paper>
      </BasePathProvider>
    </SelectedTeacherContext.Provider>
  )
}
